/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type UniversalClinicActions =
  (typeof UniversalClinicActions)[keyof typeof UniversalClinicActions];

export const UniversalClinicActions = {
  INTRO_AV_CALL: "INTRO_AV_CALL",
} as const;
